export const /** @type {?} */ HJ_FIRST_LOAN_FORM = 'first_loan_form';
